import type { ApiResponse } from '@bitstopco/bitstop-theme';

import api from '@/store/api';
import { athena, unity } from '@/store/api/instances';
import type { PatchAtmProductsRequest } from '@/types';
import type { AtmProductStateResponse } from '@/types/generated/athena';

/**
 * Machine Products RTK-Query API
 * For more information about RTK-Query see
 * * https://redux-toolkit.js.org/rtk-query/overview
 */
export const machineProductsApi = api.injectEndpoints({
  endpoints: (build) => ({
    // GET product state from Athena
    getAtmProductState: build.query<ApiResponse<AtmProductStateResponse>, number>({
      query: (atmId) => athena({ url: `v2/Atm/${atmId}/product-state` }),
      providesTags: (_, __, atmId) => [{ type: 'Machine', id: atmId }],
    }),

    // PATCH products via Unity (reuse existing endpoint)
    patchAtmProducts: build.mutation<any, PatchAtmProductsRequest>({
      query: (data) => unity({ url: 'products/atms', method: 'PATCH', data }),
      invalidatesTags: ['Machine', 'Machines'],
    }),
  }),
});

export const { useGetAtmProductStateQuery, usePatchAtmProductsMutation } = machineProductsApi;

export const {
  endpoints: { getAtmProductState, patchAtmProducts },
} = machineProductsApi;
